<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_payFlow"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="findList">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <!-- 交易记录 / 资金分配记录 -->
    <vxe-table
      ref="xTable"
      toolbar="toolbarId_payFlow"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      row-id="id_remitDefiniteForPay"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      height="580"
      show-footer
      class="mytable-footer"
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <!-- <vxe-table-column type="checkbox" width="60" /> -->
      <!-- 承运主体 -->
      <vxe-table-column>
        <vxe-table-column
          field="subCompanyName"
          title="子公司名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.subCompanyName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 类型 -->
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="类型"
          min-width="200"
          :formatter="formatterType"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.type" placeholder="请选择" clearable>
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="beforeParentAvail"
          title="分配前额度"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <!-- <el-input v-model="listQuery.amount" placeholder="请输入" clearable /> -->
          <el-row>
            <el-col :span="11">
              <el-input
                v-model.number="listQuery.beforeParentAvailMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model.number="listQuery.beforeParentAvailMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- 运费类型 -->
      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="分配额度"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <!-- <el-input v-model="listQuery.amount" placeholder="请输入" clearable /> -->
          <el-row>
            <el-col :span="11">
              <el-input
                v-model.number="listQuery.amountMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model.number="listQuery.amountMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="afterParentAvail"
          title="分配后额度"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <!-- <el-input v-model="listQuery.amount" placeholder="请输入" clearable /> -->
          <el-row>
            <el-col :span="11">
              <el-input
                v-model.number="listQuery.afterParentAvailMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model.number="listQuery.afterParentAvailMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- 支付类型 -->
      <vxe-table-column>
        <vxe-table-column
          field="createdByName"
          title="分配人"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="分配时间"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!-- <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="800"
      height="740"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal> -->
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
      :transfer="true"
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <vxe-modal
      v-model="isPdfPreview"
      width="1200"
      height="80%"
      title="回单详情"
      resize
      :transfer="true"
    >
      <MultifilePreview v-if="isPdfPreview" :pdf-urls="pdfUrls" />
    </vxe-modal>
    <!-- 转账 -->
    <vxe-modal
      v-model="isTransfer"
      width="460"
      height="300"
      title="转账"
      resize
      :transfer="true"
    >
      <TransferDetail
        v-if="isTransfer"
        :transform-info="transformInfo"
        @success="updateTransList"
      />
    </vxe-modal>
  </div>
</template>
<script>
import TransferDetail from "./transferDetail.vue";
import MultifilePreview from "@/components/MultifilePreview/index";
import ordergoods from "@/components/WaybillDetails";
// import compEdit from "./components/remitDefiniteForPayEdit.vue";
import { electronicReceipt, queryReceiptNo } from "@/api/InternetBanking";
import request from "@/utils/request";
import { getListDict } from "@/api/commonApi";
export default {
  name: "AccountRecord",
  components: {
    ordergoods,
    MultifilePreview,
    TransferDetail
  },
  props: {
    enterpriseName: {
      type: String,
      default: ""
    },
    recordType: {
      type: String,
      default: ""
    },
    partyCode: {
      type: String,
      default: ""
    },
    currentBranchCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isTransfer: false,
      transformInfo: null,
      isDisabled: false,
      pdfUrls: "",
      isPdfPreview: false,
      callbackTimeRange: "",
      loading: false,
      tableData: [],
      dialogTableVisible: false,
      ModelCashMoney: false,
      showElectronicReceiptFlag: false,
      showElectronicReceiptUrl: "",
      modelEditFlag: false,
      modelDetailFlag: false,
      errorData: [],
      parentData: {
        payStatusOptions: [
          { label: "处理中", value: "0" },
          { label: "支付成功", value: "1" },
          { label: "支付失败", value: "2" }
        ]
      },
      exportObj: {
        exportUrl: "/ntocc-tms-api/remitDefinite/exportListForPay", //导出接口
        name: "支付明细"
      },
      listQuery: {
        pageNum: 1,
        pageSize: 20
      },
      accdata: [],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      sendFundOptions: [
        { value: "0", label: "未上报" },
        { value: "1", label: "已上报" },
        { value: "2", label: "上报失败" }
      ],
      typeOptions: [{ value: 1, label: "分配" }, { value: 2, label: "回收" }],
      remitDefiniteForPay_search_button: true,
      remitDefiniteForPay_edit_button: true,
      bankList: [],
      tuteship: false,
      Pagingconf: []
    };
  },
  watch: {
    currentBranchCode: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.isDisabled = true;
          this.listQuery.branchCode = newValue;
        } else {
          this.isDisabled = false;
        }
      },
      immediate: true
    },
    partyCode: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.findList(newValue);
        }
      },
      immediate: true
    }
  },

  created() {
    this.parentData.isPayAdvanceOptions = [
      { label: "到付运费", value: 0 },
      { label: "预付运费", value: 1 },
      { label: "回单运费", value: 2 }
    ];
    this.parentData.payTypeOptions = [
      { label: "油点", value: "1" },
      { label: "加油", value: "2" },
      { label: "转账支付", value: "3" },
      { label: "余额支付", value: "4" },
      { label: "合并支付", value: "5" },
      { label: "凭证支付", value: "9" },
      { label: "银行支付", value: "10" }
    ];
    this.remitDefiniteForPay_search_button = this.getLimit(
      "remitDefiniteForPay_search_button"
    );
    this.remitDefiniteForPay_edit_button = this.getLimit(
      "remitDefiniteForPay_edit_button"
    );
    // this.findList();
  },

  methods: {
    updateTransList() {
      this.isTransfer = false;
      this.findList();
    },
    payOther(item) {
      this.transformInfo = item;
      this.isTransfer = true;
    },
    handlePageChange({ currentPage, pageSize }) {
      console.log("currentPage, pageSize", currentPage, pageSize);
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList(this.partyCode);
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    findList() {
      this.loading = true;
      let data =
        this.recordType === "all"
          ? {
              partyCode: this.partyCode,
              branchCode: this.currentBranchCode,
              ...this.listQuery
            }
          : { paidFeeType: 0, userCode: this.partyCode, ...this.listQuery };
      delete data.total;
      data.partyCode = this.partyCode;
      let url = "/ntocc-basic-api/allocationRecord";

      return request({
        // url: ,
        url: url,
        method: "get",
        params: data
      }).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        if (this.listQuery.total > 100) {
          this.Pagingconf = [20, 30, 50, 100, response.data.total];
        } else {
          this.Pagingconf = [20, 30, 50, 100];
        }
        this.loading = false;
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value == cellValue
      );
      return item ? item.label : "";
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    async funcSerial(item) {
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要获取的项");
        return;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return;
      }
      let branchCode = checkedRowArray[0].branchCode;
      let codes = [];
      for (let subItem of checkedRowArray) {
        if (subItem.branchCode != branchCode) {
          this.$message.warning("请选择同一机构");
          return;
        }
        if (
          subItem.payType != "10" ||
          subItem.payStatus != "1" ||
          subItem.orderNo
        ) {
          this.$message.warning(
            "请选择银行支付已支付成功并且未获取流水号的数据"
          );
          return;
        }
        codes.push(subItem.orderDetailCode);
      }
      codes = codes.join(",");
      const rLoading = this.openLoading();
      let response = await queryReceiptNo({ codes });
      rLoading.close();
      this.$message.success(response.msg);
      this.findList();
    },
    lookReceipt(row) {
      if (!row.payReceiptImg) {
        this.$message({ message: "暂无回单", type: "warning" });
      }
      if (row.payReceiptImg) {
        this.pdfUrls = row.payReceiptImg;
        this.isPdfPreview = true;
      }
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    formatterSendFundStatus({ cellValue }) {
      let item = this.sendFundOptions.find(item1 => item1.value == cellValue);
      return item == null ? "" : item.label;
    },
    formatterType({ cellValue }) {
      const item = this.typeOptions.find(item1 => item1.value == cellValue);
      return item ? item.label : "";
    },
    // 表格底部统计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "amount") {
            const sum = this.$XEUtils.sum(data, column.property);
            return sum != null ? sum : "-";
          } else {
            return "--";
          }
        })
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.containerTable {
  height: 682px;
}
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.green_text {
  color: green;
  font-weight: bold;
}
.red_text {
  color: red;
  font-weight: bold;
}
</style>
